var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// This is a generated file from running the "createIcons" script. This file should not be updated manually.
import React, { forwardRef } from "react";
import { SVGIcon } from "@react-md/icon";
export var MenuSVGIcon = forwardRef(function MenuSVGIcon(props, ref) {
    return (React.createElement(SVGIcon, __assign({}, props, { ref: ref }),
        React.createElement("path", { d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" })));
});
//# sourceMappingURL=MenuSVGIcon.js.map